/* global Sys, Utils, Services */
Sys.ns("Utils");

Utils.Helpers = {

    /**
     * Decodes an encoded string of data and returns it.
     *
     * @private
     * @param {string} data The data that should be decoded.
     * @returns {string} Returns the decoded string or just the string if no decoding was needed.
     */
    decodeDataString: function(data) {
        if (data.match(/%/)) {
            return decodeURIComponent(data);
        }
        return data;
    },

    /**
     * Gets the custom coin values provided in the query string or null if they are not among the initial values.
     *
     * @example
     * The values are taken from the query string that is on the format:
     *
     * customConfiguration.coinValues=1%252C5%252C100%252C25%252C50%252C100
     * @param {number[]} initialValues All denominations from server response.
     * @param {Object} queryData An object containing query data key value pairs.
     * @returns {Array} The array containing the custom coin values or empty array if they were invalid.
     */
    getCustomCoinValues: function(initialValues, queryData) {
        var decodedValueArray,
            decodedValues,
            coinValue,
            updatedCoinValues = [],
            filteredKeys,
            i,
            coinValuesExist,
            customCoinValue = queryData["customConfiguration.coinValues"];

        coinValuesExist = Sys.isDefined(queryData["customConfiguration.coinValues"]) ||
            Sys.isDefined(queryData["customConfiguration.coinValues.0"]);

        if (typeof initialValues === "undefined" || !coinValuesExist) {
            return [];
        }

        // this condition checks if custom coin values are availble in case of mobile redirect
        // In case of redirect it sends post request to gameLauncher and modifies the URL params
        if (Sys.isDefined(queryData["customConfiguration.coinValues.0"])) {
            filteredKeys = Object.keys(queryData).filter(function(keys) {
                return keys.indexOf("customConfiguration.coinValues") !== -1;
            });

            customCoinValue = filteredKeys.map(function(coinValuesKey) {
                return queryData[coinValuesKey];
            }).join();
        }

        decodedValues = this.decodeDataString(customCoinValue);

        if (decodedValues.trim().length === 0) {
            return [];
        }

        decodedValueArray = decodedValues.split(",");

        for (i = 0; i < decodedValueArray.length; i++) {
            coinValue = parseInt(decodedValueArray[i], 10);

            if (initialValues.indexOf(coinValue) === -1) {
                return [];
            }

            updatedCoinValues.push(coinValue);
        }

        return updatedCoinValues.sort(function(a, b) {
            return a - b;
        });
    },

    getISODate: function() {
        var date = new Date();

        return date.toISOString();
    },

    /**
     * Helper for getting currency text for win presentation.
     *
     * @returns {string} currency string.
     */
    getCurrencyValue: function() {
        var currencyFormat = Services.money.getCurrencyFormat();

        if (currencyFormat.showCurrencyChar) {
            if (currencyFormat.symbol) {
                return currencyFormat.symbol;
            }
            return currencyFormat.iso;
        }
        return "";
    },

    /**
     * Logs to datalake through netent_gcc public api.
     *
     * @param {string} name Name of event.
     * @param {Object | undefined} eventData Optional event data.
     * @param {boolean | undefined} extendedMetaData Optional extended meta data, primarily used for logging errors.
     * @returns {void}
     */
    logData: function(name, eventData, extendedMetaData) {
        if (!window.netent_gcc || !window.netent_gcc.Api || !window.netent_gcc.Api.logData) {
            return;
        }
        try {
            window.netent_gcc.Api.logData(name, eventData, extendedMetaData);
        }
        catch (e) {
            // Do nothing
        }
    },

    /**
     * Logs error and handles the creation of eventdata for errorLogs.
     *
     * @param {string} name Event name.
     * @param {number | string} code Error code.
     * @param {Error} error Javascript error.
     * @returns {void}
     */
    logError: function(name, code, error) {
        var eventData = {
            errorLogs: [{
                clts: this.getISODate(),
                code: code || 400,
                msg: error.stack,
                src: "origin"
            }]
        };

        this.logData(name, eventData, true);
    },

    /**
     * Logs general player interactions.
     *
     * @param {string} type Interaction typ. For example moneyModeChanged.
     * @param {any} valueBefore The value it changes from.
     * @param {any} valueAfter The new value.
     * @returns {void}
     */
    logPlayerInteracted: function(type, valueBefore, valueAfter) {
        var eventData = {
            interaction: {
                type: type,
                data: {
                    valueBefore: valueBefore,
                    valueAfter: valueAfter
                }
            }
        };

        this.logData("PLAYER_INTERACTED", eventData, false);
    }
};
